import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  AdminTableResponse,
  DataSetTableResponse,
  HospitalDataSetsResponse,
  HospitalInfoResponse,
  HospitalsListResponse,
  HospitalsOverviewResponse,
} from '../models/api-responses';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private baseUrl = environment.api.serverUrl;
  private http = inject(HttpClient);

  getHospitalsOverview(): Observable<HospitalsOverviewResponse> {
    return this.http.get<HospitalsOverviewResponse>(
      `${this.baseUrl}/hospital/overview`,
      {
        withCredentials: true,
      },
    );
  }

  getHospitalsList(): Observable<HospitalsListResponse> {
    return this.http.get<HospitalsListResponse>(
      `${this.baseUrl}/hospital/list`,
      { withCredentials: true },
    );
  }

  getHospitalInfo(id: number): Observable<HospitalInfoResponse> {
    return this.http.get<HospitalInfoResponse>(
      `${this.baseUrl}/hospital/${id}/info`,
      {
        withCredentials: true,
      },
    );
  }

  getHospitalDataSets(id: number): Observable<HospitalDataSetsResponse> {
    return this.http.get<HospitalDataSetsResponse>(
      `${this.baseUrl}/hospital/${id}/dataSets`,
      {
        withCredentials: true,
      },
    );
  }

  getDataSetTableData(
    id: number,
    snapshot?: number,
  ): Observable<DataSetTableResponse> {
    const options = {
      withCredentials: true,
      ...(snapshot !== undefined
        ? { params: new HttpParams().set('snapshot', snapshot) }
        : {}),
    };

    return this.http.get<DataSetTableResponse>(
      `${this.baseUrl}/data-set/${id}/table`,
      options,
    );
  }

  getAdminTableData(): Observable<AdminTableResponse> {
    return this.http.get<AdminTableResponse>(`${this.baseUrl}/admin/table`, {
      withCredentials: true,
    });
  }
}
